/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MovementExecution {
  createdBy?: string;
  errorCount?: number;
  executionId?: number;
  finishedAt?: Date;
  movementLabel?: string;
  movementType?: string;
  notFoundCount?: number;
  shippingCompanyInfo?: string;
  shippingOrderTypeId?: number;
  startedAt?: Date;
  status?: string;
  stockBucket?: string;
  successCount?: number;
  totalEmails?: number;
}
